import FindPostViewerContainer from "../../containers/find/FindPost/FindPostViewerContainer";

const FindPostViewerPage = () => {
  return (
    <>
      <FindPostViewerContainer />
    </>
  )
}

export default FindPostViewerPage